import dataapi from '@/api/data'

const data = {
  state: {
    total: 0,
    exportToChina: {},
    exportToChinaTable: {},
    exportToChinaOrigin: {},
    countrySlaughter: {},
    countrySlaughterOrigin: {},
    plantSlaughter: {},
    plantSlaughterOrigin: {},
    plantSlaughterPlantNo: {},
    greyChannel: {},
    greyChannelOrigin: {},
    customData: {},
    customItem: {},
    customOrigin: {},
    customReport: [],
    approvePlantOrigin: {},
    approvePlantPlantNo: {},
    approvePlantProvince: {},
    approvePlantData: [],
    approvePlantPattern: [],
    porkToChina: {},
    porkToChinaOrigin: {},
    plantPermission: {},
    marketIndexTab: '_approve_status'
  },

  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_PORK_TO_CHINA: (state, porkToChina) => {
      state.porkToChina = porkToChina
    },
    SET_PORK_TO_CHINA_ORIGIN: (state, porkToChinaOrigin) => {
      state.porkToChinaOrigin = porkToChinaOrigin
    },
    SET_EXPORT_TO_CHINA: (state, exportToChina) => {
      state.exportToChina = exportToChina
    },
    SET_EXPORT_TO_CHINA_TABLE: (state, exportToChinaTable) => {
      state.exportToChinaTable = exportToChinaTable
    },
    SET_EXPORT_TO_CHINA_ORIGIN: (state, exportToChinaOrigin) => {
      state.exportToChinaOrigin = exportToChinaOrigin
    },
    SET_COUNTRY_SLAUGHTER: (state, countrySlaughter) => {
      state.countrySlaughter = countrySlaughter
    },
    SET_COUNTRY_SLAUGHTER_ORIGIN: (state, countrySlaughterOrigin) => {
      state.countrySlaughterOrigin = countrySlaughterOrigin
    },
    SET_PLANT_SLAUGHTER: (state, plantSlaughter) => {
      state.plantSlaughter = plantSlaughter
    },
    SET_PLANT_SLAUGHTER_ORIGIN: (state, plantSlaughterOrigin) => {
      state.plantSlaughterOrigin = plantSlaughterOrigin
    },
    SET_PLANT_SLAUGHTER_PLANTNO: (state, plantSlaughterPlantNo) => {
      state.plantSlaughterPlantNo = plantSlaughterPlantNo
    },
    SET_GREY_CHANNEL: (state, greyChannel) => {
      state.greyChannel = greyChannel
    },
    SET_GREY_CHANNEL_ORIGIN: (state, greyChannelOrigin) => {
      state.greyChannelOrigin = greyChannelOrigin
    },
    SET_CUSTOM_DATA: (state, customData) => {
      state.customData = customData
    },
    SET_CUSTOM_ITEM: (state, customItem) => {
      state.customItem = customItem
    },
    SET_CUSTOM_ORIGIN: (state, customOrigin) => {
      state.customOrigin = customOrigin
    },
    SET_CUSTOM_REPORT: (state, customReport) => {
      state.customReport = customReport
    },
    SET_APPROVE_PLANT_ORIGIN: (state, approvePlantOrigin) => {
      state.approvePlantOrigin = approvePlantOrigin
    },
    SET_APPROVE_PLANT_PLANTNO: (state, approvePlantPlantNo) => {
      state.approvePlantPlantNo = approvePlantPlantNo
    },
    SET_APPROVE_PLANT_PROVINCE: (state, approvePlantProvince) => {
      state.approvePlantProvince = approvePlantProvince
    },
    SET_APPROVE_PLANT_DATA: (state, approvePlantData) => {
      state.approvePlantData = approvePlantData
    },
    SET_APPROVE_PLANT_PATTERN: (state, approvePlantPattern) => {
      state.approvePlantPattern = approvePlantPattern
    },
    SET_MARKETINDEXTAB: (state, marketIndexTab) => {
      state.marketIndexTab = marketIndexTab
    },
    SET_PLANT_PERMISSION: (state, plantPermission) => {
      state.plantPermission = plantPermission
    }
  },

  actions: {
    // 查询输华离港国别
    GetFrontExportToChinatOrigin({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontExportToChinatOrigin(params).then(response => {
          commit('SET_EXPORT_TO_CHINA_ORIGIN', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询输华离港数据
    GetFrontExportToChinatData({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontExportToChinatData(params).then(response => {
          commit('SET_EXPORT_TO_CHINA', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询国家屠宰国别
    GetFrontCountrySlaughterOrigin({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontCountrySlaughterOrigin(params).then(response => {
          commit('SET_COUNTRY_SLAUGHTER_ORIGIN', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询国家屠宰数据
    GetFrontCountrySlaughterData({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontCountrySlaughterData(params).then(response => {
          commit('SET_COUNTRY_SLAUGHTER', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询工厂屠宰国别
    GetFrontPlantSlaughterOrigin({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontPlantSlaughterOrigin(params).then(response => {
          commit('SET_PLANT_SLAUGHTER_ORIGIN', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询工厂屠宰厂号
    GetFrontPlantSlaughterPlantNo({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontPlantSlaughterPlantNo(params).then(response => {
          commit('SET_PLANT_SLAUGHTER_PLANTNO', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询工厂屠宰数据
    GetFrontPlantSlaughterData({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontPlantSlaughterData(params).then(response => {
          commit('SET_PLANT_SLAUGHTER', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询印越港数据
    GetFrontGreyChannelData({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontGreyChannelData(params).then(response => {
          commit('SET_GREY_CHANNEL', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询海关数据国别
    GetFrontCustomOrigin({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontCustomOrigin(params).then(response => {
          commit('SET_CUSTOM_ORIGIN', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询海关数据关区
    GetFrontCustomName({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontCustomName(params).then(response => {
          commit('SET_CUSTOM_ITEM', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询海关数据省份
    GetFrontCustomProvince({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontCustomProvince(params).then(response => {
          commit('SET_CUSTOM_ITEM', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询海关数据出口商
    GetFrontCustomExporter({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontCustomExporter(params).then(response => {
          commit('SET_CUSTOM_ITEM', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询海关数据部位
    GetFrontCustomCuts({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontCustomCuts(params).then(response => {
          commit('SET_CUSTOM_ITEM', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询海关数据（多选）
    GetFrontCustomMultiData({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontCustomMultiData(params).then(response => {
          commit('SET_CUSTOM_DATA', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询海关数据（单选）
    GetFrontCustomSingleData({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontCustomSingleData(params).then(response => {
          commit('SET_CUSTOM_DATA', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询海关数据进口商报表
    GetFrontCustomReportByImporter({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontCustomReportByImporter(params).then(response => {
          commit('SET_CUSTOM_REPORT', response.Data.Res)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询海关数据部位报表
    GetFrontCustomReportByCuts({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontCustomReportByCuts(params).then(response => {
          commit('SET_CUSTOM_REPORT', response.Data.Res)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询海关数据工厂报表
    GetFrontCustomReportByPlant({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontCustomReportByPlant(params).then(response => {
          commit('SET_CUSTOM_REPORT', response.Data.Res)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询准入工厂国别
    GetFrontApprovePlantOrigin({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontApprovePlantOrigin(params).then(response => {
          commit('SET_APPROVE_PLANT_ORIGIN', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询准入工厂省份
    GetFrontApprovePlantProvince({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontApprovePlantProvince(params).then(response => {
          commit('SET_APPROVE_PLANT_PROVINCE', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询准入工厂数据
    GetFrontApprovePlant({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontApprovePlant(params).then(response => {
          commit('SET_APPROVE_PLANT_DATA', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询准入工厂格局
    GetFrontApprovePlantPattern({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontApprovePlantPattern(params).then(response => {
          commit('SET_APPROVE_PLANT_PATTERN', response.Data.Patterns)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询准入工厂数据
    GetFrontGreyChannelOrigin({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontGreyChannelOrigin(params).then(response => {
          commit('SET_GREY_CHANNEL_ORIGIN', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 牛肉输华格局
    GetFrontExportToChinatTableData({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontExportToChinatTableData(params).then(response => {
          commit('SET_TOTAL', response.Data.Row.total)
          commit('SET_EXPORT_TO_CHINA_TABLE', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 猪肉输华国别
    GetFrontPorkDataOrigin({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontPorkDataOrigin(params).then(response => {
          commit('SET_PORK_TO_CHINA_ORIGIN', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 猪肉输华数据
    GetFrontPorkData({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontPorkData(params).then(response => {
          commit('SET_PORK_TO_CHINA', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 猪肉出口格局
    GetFrontPorkDataTable({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontPorkDataTable(params).then(response => {
          commit('SET_PORK_TO_CHINA', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询破壳海关数据筛选项
    GetFrontPorkDataCustomItems({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontPorkDataCustomItems(params).then(response => {
          commit('SET_PORK_TO_CHINA_ORIGIN', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询破壳海关数据走势
    GetFrontPorkDataCustomTrend({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontPorkDataCustomTrend(params).then(response => {
          commit('SET_PORK_TO_CHINA', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询破壳海关数据列表
    GetFrontPorkDataCustomList({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontPorkDataCustomList(params).then(response => {
          commit('SET_PORK_TO_CHINA', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询破壳工厂筛选项
    GetFrontPorkDataEstItems({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontPorkDataEstItems(params).then(response => {
          commit('SET_PORK_TO_CHINA_ORIGIN', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询破壳工厂列表
    GetFrontPorkDataEst({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontPorkDataEst(params).then(response => {
          commit('SET_PORK_TO_CHINA', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 统计工厂查询信息
    AddPlantSearchInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.addPlantSearchInfo(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 厂号
    GetFrontApprovePlantNo({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontApprovePlantNo(params).then((response) => {
          commit('SET_APPROVE_PLANT_PLANTNO', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetFrontApprovePlantPermission({ commit }, params) {
      return new Promise((resolve, reject) => {
        dataapi.getFrontApprovePlantPermission(params).then((response) => {
          commit('SET_PLANT_PERMISSION', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default data



// WEBPACK FOOTER //
// ./src/store/modules/data.js